import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ReactPaginate from "react-paginate";
import { useEffect } from "react";
import DataSkeleton from "../../auth_screens/dataskeleton";
import { Link } from "react-router-dom";
import "react-spring-bottom-sheet/dist/style.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Modal2 from "../../auth_screens/Modal2";
import { EmployerMobileactivityLog, findResponseEmployer, getemployerProfile } from "../../../store/slices/employerprofile";
import moment from "moment";
import { CiLock } from "react-icons/ci";
import IsViewedModal from "../../../utils/helpers/IsViewedModal";
import { BsWhatsapp } from "react-icons/bs";
import { IoMdCall } from "react-icons/io";


function ClientResponse() {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    useEffect(() => {
        document.title = "CookandChef | Find Jobs";
    }, []);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [search, setSearch] = useSearchParams();
    const [employerData, setEmployerData] = useState();
    const querypage = parseInt(search.get("page")) || 1;
    const [data, setData] = useState([]);
    const [totaldata, setTotaldata] = useState();
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [modalViewMessage, setModalViewMessage] = useState("");
    const [currentPage, setCurrentPage] = useState(querypage);
    const itemsPerPage = 25;
    const pagesToShowInitially = 3;
    const [item, setItem] = useState({
        limit: itemsPerPage,
        page: currentPage,
    });

    React.useEffect(() => {
    dispatch(getemployerProfile())
        .unwrap()
        .then((data) => {
        setEmployerData(data.user.data);
        console.log(data)
        })
        .catch(({ message }) => {
        // setModalMessage(message);
        // setShowModal(true);
        });
    }, [dispatch]);


    const errorModal = (item) => {
        setShowViewModal(true);
        setModalViewMessage(
          "You don't have enough points to view this cook's profile. Buy plan to view"
        );
      };

 useEffect(() => {
        const getjobs = () => {
            setisLoading(true);
            dispatch(findResponseEmployer(item))
                .unwrap()
                .then((data) => {
                    setisLoading(false);
                    setData(data)
                    setTotaldata(data?.totalDataCount)
                })
                .catch(({ message }) => {
                    setisLoading(false);
                 })
        };
        getjobs();
    }, [item])

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1 || currentPage;
        setCurrentPage(newPage);
        setItem({
            ...item,
            page: newPage,
        });
    };

    const handleNavigation = (item) => {
        navigate(`/client/house-cook-details/${item.id}`)
    }

    const activityTypeMapping = {
        'chatinteraction': 'Chat',
        'mobileinteraction': 'Call',
        'whatsappinteraction': 'Whatsapp',
        'applied': 'Applied',
        'shortlisted': 'Shortlisted',
        'viewed': 'Viewed Contact',
        'cancelled': 'Cancelled',
        'viewedmobilenumber': 'Viewed Mobile Number'
    };

    const handleInteracction = async (activity,cook) => {
      const item = {
        cookId:cook?.cookId?.id,
        activity
      };
      try {
        await dispatch(EmployerMobileactivityLog(item)).unwrap();
  
        if (activity === "mobileinteraction") {
          window.location.href = `tel:${cook?.cookId?.mobile}`;
        } else if (activity === "whatsappinteraction") {
          window.location.href = `https://api.whatsapp.com/send?phone=${cook?.cookId?.whatsappNumber}`;
        }
        //  else if (value === "chatinteraction") {
        //   let member2;
        //   let res;
        //   const weavyid = parseInt(localStorage.getItem("weavyId"));
        //   const member1 = parseInt(user?.data?.weavyId) || weavyid;
  
        //   const chatroomName = data?.fullName;
        //   if (!data.weavyId) {
        //     const requestOptions = {
        //       method: "POST",
        //       headers: {
        //         "Content-Type": "application/json",
        //         Authorization: `Bearer  ${API_PATHS.weavyKey}`,
        //       },
        //       body: JSON.stringify({
        //         uid: data?.id,
        //         name: data?.fullName,
        //       }),
        //     };
        //     const rees = await InitApp1(requestOptions, data, "cook");
        //     member2 = parseInt(localStorage.getItem("weavyId2"));
        //     const memberIds = [member1, member2];
        //     res = await createChatRoom(chatroomName, memberIds);
        //   } else {
        //     member2 = parseInt(data?.weavyId);
        //     const memberIds = [member1, member2];
        //     res = await createChatRoom(chatroomName, memberIds);
        //   }
  
        //   if (res?.id) {
        //     navigate("/client/message", {
        //       state: { res: res },
        //     });
        //   }
        // }
      } catch ({ message }) {
        alert('Error while performing the action')
      }
    };

    console.log(data)
    return (
        <>
            <Modal2
                showModal={showModal}
                modalMessage={modalMessage}
                setShowModal={setShowModal}
            />
            <IsViewedModal
                showViewModal={showViewModal}
                modalViewMessage={modalViewMessage}
                setShowViewModal={setShowViewModal}
                />
            <div>
                <div
                    className="text-start my-4"
                    style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#ff5c09",
                    }}
                >
                    <Link to="/employer/dashboard" className="bcrumb">
                        Home
                    </Link>
                    &nbsp;&bull;&nbsp;Responses
                </div>
                <div className="tablecontainer">
                    <Table className="table-custom" size="lg">
                        <thead >
                    {isLoading?(DataSkeleton()):
                            (<tr style={{fontSize: '16px'}}>
                                <th >Name</th>
                                <th className="text-center">Activity</th>
                                <th></th>
                            </tr>)}
                        </thead>
                        {isLoading?(DataSkeleton()): (data && data?.data?.length > 0 ?  <tbody>
                            {data && data?.data?.length > 0 && data.data.map((i, index) => {
                                return <tr key={index} className="borderBt-tr">
                                    <td>
                                        <p  style={{fontSize: '16px', fontWeight: 700, lineHeight: '10px', marginTop: '20px'}}>{i?.cookId?.fullName}</p>
                                        <p  style={{fontSize: '10px' }}>{moment(i?.updatedAt).format('DD MMM yyyy')}</p>
                                    </td>
                                    <td className="text-center vertical-middle" style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {activityTypeMapping[i?.activity] || i?.activity?.charAt(0).toUpperCase() + i?.activity?.slice(1)}
                                    </td>
                                    {/* <td className="text-center vertical-middle" style={{fontSize: '14px', fontWeight: 500}}>{i?.activity?.charAt(0).toUpperCase() + i?.activity?.slice(1)}                                    </td> */}
                                    <td className="text-end vertical-middle">
                                         {i?.cookId?.whatsappNumber?<button onClick={() => handleInteracction("whatsappinteraction",i)} className="contactCard" style={{border:0}}><BsWhatsapp style={{ color: "#059F14", fontSize: "25px" }} /></button>:null}
                                         {i?.cookId?.mobile?<button onClick={() => handleInteracction("mobileinteraction",i)} className="contactCard" style={{border:0}}><IoMdCall style={{ color: "#1808B1", fontSize: "25px" }} /></button>:null}
                                         {/* <ProfileViewButton 
                                        errorModal = {errorModal}
                                        item={i}
                                        employerData={employerData}
                                        handleNavigation={handleNavigation}
                                        /> */}
                                    </td>
                                </tr>
                            })}

                        </tbody>  :
                        <>
                        <p className="px-2 mt-2">No records found!</p>
                        </> 
                        )}
                    </Table>

                </div>
                {totaldata / itemsPerPage > 1 && (
                    <div className="justify-content-right align-right">
                        <ReactPaginate
                            key={currentPage}
                            previousLabel="<"
                            nextLabel=">"
                            breakLabel="..."
                            breakLinkClassName={"page-link"}
                            pageCount={Math.ceil(totaldata / itemsPerPage)}
                            marginPagesDisplayed={0}
                            pageRangeDisplayed={pagesToShowInitially}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            activeClassName="active"
                            pageLinkClassName="page-link"
                            previousLinkClassName="page-link"
                            nextLinkClassName="page-link"
                            disabledClassName="disabled"
                            initialPage={currentPage - 1}
                        />
                    </div>
                )}
            </div>
        </>
    );
}

export default ClientResponse;



export const ProfileViewButton = ({ item: i, employerData, handleNavigation,errorModal }) => {
    const hasNoPoints = employerData?.pointsData?.currentHouseCookPoints === 0;
    
    const renderViewButton = () => {
      // Case 1: Profile not viewed and no points
      if (!i?.isViewed && hasNoPoints) {
        return (
          <Button onClick={(item) => errorModal(item)} className="view_btn btn" style={{fontSize: '12px'}}>
            View Profile
          </Button>
        );
      }
      
      // Case 2: Profile already viewed
      if (i?.isViewed) {
        return (
          <Button 
            onClick={() => handleNavigation(i?.cookId)} 
            className="view_btn btn" style={{fontSize: '12px'}}
          >
            View Profile
          </Button>
        );
      }
      
      // Case 3: Profile not viewed and has points
      if (!i?.isViewed && !hasNoPoints) {
        return (
          <Link
          onClick={() => handleNavigation(i?.cookId)} 
            style={{ color: "#000" }}
          >
            <Button className="view_btn btn" style={{fontSize: '12px'}}>
            View Profile
            </Button>
          </Link>
        );
      }
    };
  
    return (
      <div className="d-flex align-items-center justify-content-end">
        {!i?.isViewed && (
          <CiLock style={{ fontSize: "20px" }} />
        )}
        <span className="ms-2" >
          {renderViewButton()}
        </span>
      </div>
    );
  };